import { Action, createReducer, on } from '@ngrx/store';

import {
  setSkipServices,
} from '@shared/base-search-bar/store/actions/search-bar.actions';

export const initialState = false;

const featureReducer = createReducer(
  initialState,
  on(setSkipServices, (state, { value }) => value)
);

export const skipServicesReducer = (state: boolean | undefined = false, action: Action): boolean => {
  return featureReducer(state, action);
};
